import VideoTemplate from './VideoTemplate'

export * from './VideoTemplate'

export default VideoTemplate
